import React from "react";

import { Link } from "gatsby";
import FinlandSignIn from "./FinlandSignIn";

import styles from "../assets/styles/FinlandNavigation.module.scss";

const FinlandNavigation = ({ location }) => {
	const navItems = [
		{ title: "Home", to: "/finland" },
		{ title: "Subpage", to: "/finland/subpage" }
	];

	const links = navItems.map(item => {
		let className = styles.item;
		if (location === item.to) className += ` ${styles.active}`;

		return (
			<li key={item.title} className={className}>
				<Link to={item.to}>{item.title}</Link>
			</li>
		);
	});

	return (
		<div className={styles.root}>
			<Link className={styles.home} to={"/finland"} />
			<ul className={styles.navigation}>{links}</ul>
			<div className={styles.signIn}>
				<FinlandSignIn />
			</div>
		</div>
	);
};

export default FinlandNavigation;
